import React from 'react'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { getHexColorFromName } from 'marketing-site/src/library/utils'

import { IRooflineBanner as IContentfulRooflineBanner } from 'marketing-site/@types/generated/contentful'
import {
  IProps as IRooflineBanner,
  RooflineBanner,
} from 'marketing-site/src/library/components/RooflineBanner'

export const ContentfulRooflineBanner = (
  rooflineBanner: IContentfulRooflineBanner,
): React.ReactElement => (
  <EntryMarker entry={rooflineBanner}>
    {() => <RooflineBanner {...transformRooflineBanner(rooflineBanner)} />}
  </EntryMarker>
)

const transformColor = (colorName: string) => {
  return getHexColorFromName(colorName)
}

export function transformRooflineBanner({ fields }: IContentfulRooflineBanner): IRooflineBanner {
  return {
    ...fields,
    backgroundColor: fields.backgroundColor && transformColor(fields.backgroundColor),
    cta: fields.cta,
  }
}
